import api from '@pray/shared/utils/api';

export async function getPrayRadioSlotAssignments({
  artistId,
}: {
  artistId?: string;
} = {}) {
  const url = '/web/studio/pray-radio/slot-assignments';
  const params = new URLSearchParams();
  if (artistId) params.set('artist_id', artistId);

  const queryString = params.toString();
  const response = await api.executeGetRequest(queryString ? `${url}?${queryString}` : url);

  return response.data;
}
